import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form as FinalForm } from 'react-final-form';
import FieldTextInput from '../FieldTextInput/FieldTextInput';
import Button from '../Button/Button';
import Form from '../Form/Form';
import css from './CommentsSection.module.css';
import { addComment } from '../../util/api';
import { loadComments } from '../../util/api';
import { deleteComment } from '../../util/api';
import Modal from '../Modal/Modal';
import IconSpinner from '../IconSpinner/IconSpinner';
import { FormattedMessage } from 'react-intl';
const CommentSection = ({ productId, commentUserId, listingAuthorId, authorName }) => {
  const [comments, setComments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [commentToDelete, setCommentToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  useEffect(() => {
    fetchComments(productId);
  }, [productId]);
  const openDeleteModal = commentId => {
    setCommentToDelete(commentId);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setCommentToDelete(null);
  };
  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      await handleDelete(commentToDelete);
      closeDeleteModal();
    } catch (error) {
      console.error('Error deleting comment:', error);
    } finally {
      setIsDeleting(false);
    }
  };

  const fetchComments = async productId => {
    try {
      const comments = await loadComments(productId);
      setComments(comments);
    } catch (error) {
      console.error('Error fetching comments:', error);
    }
  };

  const onSubmit = async (values, form) => {
    try {
      await addComment({
        productId,
        text: values.text,
        userId: commentUserId,
        authorName,
      });
      await fetchComments(productId);
      form.reset(); // Clear form after submit
    } catch (error) {
      console.error('Error creating comment:', error);
    }
  };

  const handleDelete = async commentId => {
    try {
      setIsLoading(true);
      await deleteComment({ commentId }); // Pass commentId as object
      await fetchComments(productId);
    } catch (error) {
      console.error('Error deleting comment:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={css.commentSection}>
      <h3>
        <FormattedMessage id="ListingPageCarousel.CommentSectionQuestions" />
      </h3>
      <p>
        <FormattedMessage id="ListingPageCarousel.CommentSectionAskSeller" />
      </p>
      <p className={css.disclaimerText}>
        <FormattedMessage id="ListingPageCarousel.CommentSectionNote" />
      </p>
      <FinalForm
        onSubmit={onSubmit}
        render={({ handleSubmit, form, submitting, pristine }) => (
          <Form onSubmit={values => handleSubmit(values, form)}>
            <FieldTextInput
              name="text"
              component="textarea"
              placeholder="Type your question here..."
              className={css.commentInput}
            />
            <Button
              type="submit"
              disabled={submitting || pristine || isLoading}
              className={css.commentSectionButton}
            >
              <FormattedMessage id="ListingPageCarousel.CommentSectionSubmitButtonText" />
            </Button>
          </Form>
        )}
      />

      {comments.length > 0 ? (
        comments.map(comment => (
          <div
            key={comment._id}
            className={comment.userId === listingAuthorId ? css.commentSellerItem : css.commentItem}
          >
            <div className={css.commentDetails}>
              <div className={css.commentAuthor}>
                {comment.userId === listingAuthorId
                  ? 'From the seller'
                  : `${comment.authorName} asked`}
              </div>
              <p className={css.commentText}>
                {comment.isDeleted ? <i>Message deleted</i> : comment.text}
              </p>
              {!comment.isDeleted && comment.userId === commentUserId && (
                <button onClick={() => openDeleteModal(comment._id)} className={css.deleteButton}>
                  <FormattedMessage id="ListingPageCarousel.CommentSectionDeleteButton" />
                </button>
              )}
              <Modal
                id="delete-comment-modal"
                isOpen={showDeleteModal}
                onClose={closeDeleteModal}
                closeButtonMessage="Close"
                className={css.modal}
                onManageDisableScrolling={() => {}}
              >
                <div className={css.modalContent}>
                  <h2>
                    <FormattedMessage id="ListingPageCarousel.CommentSectionDelete" />
                  </h2>
                  <p>
                    <FormattedMessage id="ListingPageCarousel.CommentSectionAreYouSureToDelete" />
                  </p>
                  <div className={css.modalButtons}>
                    <button
                      onClick={confirmDelete}
                      className={css.confirmButton}
                      disabled={isDeleting}
                    >
                      {isDeleting ? <IconSpinner /> : 'Yes, delete'}
                    </button>
                    <button
                      onClick={closeDeleteModal}
                      className={css.cancelButton}
                      disabled={isDeleting}
                    >
                      <FormattedMessage id="ListingPageCarousel.CommentSectionNoKeep" />
                    </button>
                  </div>
                </div>
              </Modal>
            </div>
          </div>
        ))
      ) : (
        <p>
          <FormattedMessage id="ListingPageCarousel.CommentSectionNoQuestions" />
        </p>
      )}
    </div>
  );
};

export default CommentSection;
